import { REPORT_TYPE } from '../constants/report_type';
import { defaultPayload } from '../components/navigation/report_attributes';

const VALID_REPORTS = Object.values(REPORT_TYPE).map(v => v.toLowerCase());

export const parseHashParams = () => {
  const hashQuery = window.location.hash.split('?')[1];
  if (!hashQuery) return {};
  const params = {};
  new URLSearchParams(hashQuery).forEach((value, key) => { params[key] = value; });
  return params;
};

export const decodeDeeplinkParams = (q, currentPayload, snapshotsMap) => {
  if (!q.report && !q.timeFrame && !q.marketplace && !q.snapshots) return null;

  const payload = Object.assign({}, currentPayload);
  let timeFrameIds = null;
  let productLineIds = null;
  let selectedComponents = null;
  const aggregateFlags = {};

  if (q.report && VALID_REPORTS.includes(q.report.toLowerCase())) payload.report = q.report;
  if (q.rollup) payload.rollup = q.rollup;
  if (q.currency) payload.currency = q.currency;
  if (q.marketplace) payload.marketplace = q.marketplace;
  if (q.timeFrame) {
    payload.timeFrame = q.timeFrame;
    timeFrameIds = q.timeFrame.split(',');
  }
  if (q.productLines) {
    payload.productLines = q.productLines;
    productLineIds = q.productLines.split(',');
  }
  if (q.component) {
    payload.component = q.component;
    selectedComponents = q.component === 'all' ? [] : q.component.split(',');
  }
  if (q.channel) payload.channel = q.channel;
  if (q.accuracyType) payload.accuracyType = q.accuracyType;
  if (q.region) payload.region = q.region;
  if (q.day) payload.day = q.day;
  if (q.aggregateTime === 'false') aggregateFlags.time = false;
  if (q.aggregateMP === 'false') aggregateFlags.marketplace = false;
  if (q.aggregatePL === 'false') aggregateFlags.productLine = false;

  let selectedSnapshots = null;
  if (q.snapshots) {
    selectedSnapshots = q.snapshots.split(',')
      .filter(id => snapshotsMap[id] && snapshotsMap[id].enabled)
      .map(id => snapshotsMap[id]);
    if (!selectedSnapshots.length) selectedSnapshots = null;
  }

  return { payload, timeFrameIds, productLineIds, selectedComponents, aggregateFlags, selectedSnapshots };
};

export const encodeHashParams = ({ payload, selectedSnapshots, timeFrameIds, productLineIds, selectedComponents, aggregatedTimeFrameSelected, aggregatedMarketplaceSelected, aggregatedProductLineSelected }) => {
  const params = new URLSearchParams();
  if (payload.report && payload.report !== defaultPayload.report) params.set('report', payload.report);
  if (payload.rollup && payload.rollup !== defaultPayload.rollup) params.set('rollup', payload.rollup);
  if (payload.currency && payload.currency !== defaultPayload.currency) params.set('currency', payload.currency);
  if (payload.marketplace) params.set('marketplace', payload.marketplace);
  const timeFrame = timeFrameIds.length ? timeFrameIds.join(',') : payload.timeFrame;
  if (timeFrame) params.set('timeFrame', timeFrame);
  const productLines = productLineIds.length ? productLineIds.join(',') : payload.productLines;
  if (productLines && productLines !== defaultPayload.productLines) params.set('productLines', productLines);
  const component = selectedComponents.length ? selectedComponents.join(',') : payload.component;
  if (component && component !== defaultPayload.component) params.set('component', component);
  if (payload.channel && payload.channel !== defaultPayload.channel) params.set('channel', payload.channel);
  if (payload.accuracyType && payload.accuracyType !== defaultPayload.accuracyType) params.set('accuracyType', payload.accuracyType);
  if (payload.region) params.set('region', payload.region);
  if (payload.day) params.set('day', payload.day);
  if (selectedSnapshots.length) params.set('snapshots', selectedSnapshots.map(s => s.id).join(','));
  if (!aggregatedTimeFrameSelected) params.set('aggregateTime', 'false');
  if (!aggregatedMarketplaceSelected) params.set('aggregateMP', 'false');
  if (!aggregatedProductLineSelected) params.set('aggregatePL', 'false');
  return params.toString();
};

export const updateUrlHash = (queryString) => {
  const hashPath = window.location.hash.split('?')[0] || '#/';
  window.history.replaceState(null, '', queryString ? `${hashPath}?${queryString}` : hashPath);
};

export const copyToClipboard = async (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try { await navigator.clipboard.writeText(text); return true; } catch (e) { /* fallback */ }
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  return true;
};



// WEBPACK FOOTER //
// ./src/utils/deeplink-utils.js